import cvLogo from '../assets/icons/logo.svg';
import gsLogo from '../assets/icons/GSLogo.svg';

export const getReferralLetterLogo = (downloadForGs: boolean) => {
  if (downloadForGs) {
    return {
      src: gsLogo,
      style: 'width:160px; filter:brightness(0);',
      alt: 'GetScanned',
    };
  }

  return {
    src: cvLogo,
    style: 'width:120px;',
    alt: 'CoreVitals',
  };
};
